import {
	ADMIN_PAGE_MODULE,
	ISSUE_ACTIVITY_MODULE,
	ISSUE_GLANCE_MODULE,
	ISSUE_PANEL_MODULE,
	PROJECT_PAGE_MODULE,
} from '@atlassian/jira-forge-ui-constants/src/constants.tsx';
import type { ViewportSizeType } from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';
import type { ExtensionPointModule } from '@atlassian/jira-forge-ui-types/src/common/types/module.tsx';

type ViewportSizeObjectType = Partial<Record<ViewportSizeType, string>> & { default: string };

const panelHeights: ViewportSizeObjectType = {
	default: '100%',
	small: '112px',
	medium: '262px',
	large: '524px',
	xlarge: '1048px',
};

const issueGlanceHeights: ViewportSizeObjectType = {
	// subtraction was added to solve the scrolling bug
	default: 'calc(100% - 4px)',
};

const fullPageHeights: ViewportSizeObjectType = {
	default: '100%',
};

const extensionPointHeights: Partial<Record<ExtensionPointModule, ViewportSizeObjectType>> = {
	[ISSUE_PANEL_MODULE]: panelHeights,
	[ISSUE_ACTIVITY_MODULE]: panelHeights,
	[ISSUE_GLANCE_MODULE]: issueGlanceHeights,
	[ADMIN_PAGE_MODULE]: fullPageHeights,
	[PROJECT_PAGE_MODULE]: fullPageHeights,
};

export const calculateHeight = (
	type: ExtensionPointModule,
	size?: ViewportSizeType,
	isInModal?: boolean,
): string => {
	if (isInModal === true) return '100%';

	const heights = extensionPointHeights[type];
	if (!heights) {
		return '100%';
	}

	if (size) {
		return heights[size] ?? heights.default;
	}

	return heights.default;
};
